import React from 'react';
import { styles } from '../styles';

const LoadingState = ({ message = 'Loading policy details...' }) => {
  return (
    <div style={styles.loadingContainer}>
      <p>{message}</p>
    </div>
  );
};

export default LoadingState;
